import Vue from "vue"
import VueI18n from "vue-i18n"
import Cookies from "js-cookie"
import { merge } from "lodash"
import { getTenantId } from "@/plugins/env"
import commonEN from "@/assets/lang/en"
import commonZH from "@/assets/lang/zh"
import mpjEN from "@/assets/lang/mpj/en"
import mpjZH from "@/assets/lang/mpj/zh"
import wellcomeEN from "@/assets/lang/wellcome/en"
import wellcomeZH from "@/assets/lang/wellcome/zh"

if (!Vue.__use_i18n__) {
  Vue.__use_i18n__ = true
  Vue.use(VueI18n)
}

export function getLanguage(app) {
  if (process.server) {
    return app.$cookies.get("superweb-locale") || "zh_HK"
  } else {
    return Cookies.get("superweb-locale") || "zh_HK"
  }
}

let i18n

export const translate = function (key, params) {
  return (i18n && i18n.t(key, params)) || key
}

export default ({ app }) => {
  let en = commonEN
  let zh = commonZH
  const tenantId = getTenantId()
  switch (tenantId) {
    case 0:
      en = merge(commonEN, mpjEN)
      zh = merge(commonZH, mpjZH)
      break
    case 15:
      en = merge(commonEN, wellcomeEN)
      zh = merge(commonZH, wellcomeZH)
      break
    default:
      break
  }
  i18n = new VueI18n({
    locale: getLanguage(app),
    messages: {
      en_US: en,
      zh_HK: zh
    }
  })
  app.i18n = i18n
}
